import React from "react";
import "./ButtonRed.css";

function ButtonRed({
  labelText = "Red Button",
  onClick = () => alert("Red Button Clicked"),
  fontSize = 28,
}) {
  return (
    <div className='button-red-cover'>
      <div
        className='button-red'
        onClick={onClick}
        style={{
          borderImageSource: "url('/btn-frame-red.png')",
          borderImageSlice: `${fontSize / 2} fill`,
          padding: `0 ${fontSize}px`,
          borderWidth: `${fontSize / 2}px`,
        }}
      >
        <label
          className='button-red-label'
          style={{
            fontSize: fontSize,
          }}
        >
          {labelText}
        </label>
      </div>
    </div>
  );
}

export default ButtonRed;
